import React from 'react';
import { Icon, Input } from 'Components';
import styles from './FilterSearch.module.scss';

const LABEL_MAP: Record<string, string> = {
	roles: 'Role',
	property: 'Property',
	individual: 'Individual'
};

interface Props {
	filterType: string;
	value: string;
	onChange: (value: string) => void;
}

const FilterSearch: React.FC<Props> = ({ filterType, value, onChange }) => {
	const label = LABEL_MAP[filterType];
	if (!label) return null;

	return (
		<div className={styles.wrapper}>
			<div className={styles.label}>Select {label}</div>
			<Input.Search
				className={styles.input}
				placeholder={`Search ${label}`}
				suffix={<Icon type="search" role="img" />}
			/>
		</div>
	);
};

export default FilterSearch;
